export default function ProductSkeleton() {
  return (
    <div className="bg-white border border-neutral-100 rounded-2xl overflow-hidden animate-pulse" style={{ width: '220px' }}>
      {/* Square image placeholder */}
      <div className="bg-neutral-100" style={{ aspectRatio: '1 / 1' }} />
      {/* Info */}
      <div className="px-3 pt-3 pb-3.5 space-y-2">
        <div className="h-2.5 bg-neutral-100 rounded-full w-1/3" />
        <div className="h-3.5 bg-neutral-100 rounded-full w-5/6" />
        <div className="h-3 bg-neutral-100 rounded-full w-2/3" />
        <div className="flex items-center justify-between pt-2 border-t border-neutral-100">
          <div className="h-4 bg-neutral-100 rounded-full w-1/3" />
          <div className="w-7 h-7 bg-neutral-100 rounded-full" />
        </div>
      </div>
    </div>
  );
}
